const getPropertyId = (hotelPreview, property) =>
  hotelPreview?.propertyId ?? property?.id?.toString() ?? ''
const getPropertyName = (hotelPreview, property) =>
  hotelPreview?.propertyName ?? property?.name ?? ''
const getPropertyStars = (hotelPreview, property) =>
  hotelPreview?.propertyStars ?? property?.stars ?? null
const getCitySlug = (hotelPreview, property) =>
  property?.citySlug ?? hotelPreview?.propertyCity?.toLowerCase() ?? ''
const getCountry = (hotelPreview, property) =>
  property?.country ?? hotelPreview?.propertyCountry ?? ''

const getAddressString = property => {
  const addressParts = []
  if (property?.address) {
    addressParts.push(property.address)
  }
  if (property?.postalCode) {
    addressParts.push(property.postalCode)
  }
  if (property?.city) {
    addressParts.push(property.city)
  }
  return addressParts.join(' ').trim()
}

const getFullAddress = (hotelPreview, property) =>
  hotelPreview?.fullAddress ?? getAddressString(property) ?? ''

const getMapPreview = ({ propertyLocation } = {}) => {
  if (!propertyLocation) {
    return ''
  }
  const { latitude, longitude } = propertyLocation
  return `https://maps.googleapis.com/maps/api/staticmap?size=270x180&center=${latitude},${longitude}&zoom=13&key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}&markers=${latitude},${longitude}`
}

export {
  getPropertyId,
  getPropertyName,
  getPropertyStars,
  getCitySlug,
  getCountry,
  getMapPreview,
  getFullAddress,
  getAddressString,
}
